<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="sideOverShow = false"
		></div>
		<PercentSlideOver
			@close="sideOverShow = false"
			@submit="submit"
			:sideOverShow="sideOverShow"
			:endPercent="autoFillData?.end_percent"
			:startPercent="autoFillData?.start_percent"
			:nextPlan="autoFillData?.next_plan_for_unlearned_goal"
		/>
	</div>
	<div class="h-full w-full">
		<div
			class="__setup-target-smart __section shadow-sm bg-white overflow-hidden"
		>
			<div
				class="__section__header font-semibold text-neutral-600 p-6 border-b"
			>
				<div class="text-neutral-600">Báo cáo bắt buộc</div>

				<div
					class="text-neutral-500 font-normal leading-5 text-sm mt-2"
					style="max-width: 700px"
				>
					{{ $filters.terminology('teacher') }} bắt buộc phải hoàn thành các loại báo cáo được
					bật bên dưới.
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div
							class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
						>
							Báo cáo tuần
						</div>
						<SwitchButton v-model:value="enable_weekly_report" />
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">
					Nhận xét và ghi chú trong báo cáo cá nhân
				</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					Ở chế độ bật, {{ $filters.terminology('teacher') }} bắt buộc phải điền nhận xét buổi
					học và ghi chú cho mục tiêu để có thể hoàn thành báo cáo của
					buổi học can thiệp cá nhân.
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div
							class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
						>
							Nhận xét buổi học
						</div>
						<SwitchButton v-model:value="require_report_note" />
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6"
					>
						<div
							class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
						>
							Ghi chú cho mục tiêu
						</div>
						<SwitchButton v-model:value="require_goal_note" />
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">
					Tự động hoàn thành báo cáo tháng
				</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					Ở chế độ bật, cơ sở can thiệp có thể tự động hoàn thành báo
					cáo tháng
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div
							class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
						>
							Bật chế độ Tự động
						</div>
						<SwitchButton
							v-model:value="enable_auto_fill_assessment_report"
						/>
					</div>
				</div>
			</div>
			<div
				class="__section__header font-semibold p-6 border-b"
				v-if="enable_auto_fill_assessment_report"
			>
				<div class="text-neutral-600">Mục tiêu có kết quả</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="input-group__label w-1/3 uppercase text-neutral-400 text-xs font-semibold"
					>
						Kết quả lớn hơn {{ autoFillData?.end_percent }}%
					</div>
					<div class="goal-class">Mục tiêu hoàn thành</div>
				</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="input-group__label w-1/3 uppercase text-neutral-400 text-xs font-semibold"
					>
						Kết quả đạt {{ autoFillData?.start_percent }}% -
						{{ autoFillData?.end_percent }}%
					</div>
					<div class="goal-class">Mục tiêu lặp lại vào tháng tới</div>
				</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="input-group__label w-1/3 uppercase text-neutral-400 text-xs font-semibold"
					>
						Kết quả nhỏ hơn {{ autoFillData?.start_percent }}%
					</div>
					<div class="goal-class">Mục tiêu tạm dừng</div>
				</div>
				<div class="text-neutral-600">Mục tiêu chưa được dạy</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="input-group__label w-1/3 uppercase text-neutral-400 text-xs font-semibold"
					>
						mặc định
					</div>
					<div
						class="goal-class"
						v-if="
							autoFillData?.next_plan_for_unlearned_goal ===
							'continued'
						"
					>
						Lặp lại mục tiêu
					</div>
					<div
						class="goal-class"
						v-if="
							autoFillData?.next_plan_for_unlearned_goal ===
							'stopped'
						"
					>
						Tạm dừng mục tiêu
					</div>
				</div>
				<div class="py-6 flex justify-end">
					<button
						type="button"
						class="button-p text-center whitespace-nowrap w-max"
						@click="sideOverShow = true"
					>
						Chỉnh sửa
					</button>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
			v-if="!isLitePackage"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">Gửi báo cáo</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					CSCT có thể lựa chọn các báo cáo được tự động gửi đến app
					Phụ huynh
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo bán trú
							</div>
							<div
								class="font-normal text-neutral-500 leading-5 text-xs mt-2"
							>
								{{
									enable_day_care_report_sent
										? `Ở chế độ bật, các báo cáo bán trú sẽ được tự động gửi đến phụ huynh sau khi hoàn thành.`
										: `Ở chế độ tắt, chỉ có giám đốc, quản lý cơ sở, trưởng chuyên môn và ${$filters.terminology('teacher')} thực hiện báo cáo mới có thể chọn gửi đến cho phụ huynh.`
								}}
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_day_care_report_sent"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-white"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo can thiệp cá nhân
							</div>
							<div
								class="font-normal text-neutral-500 leading-5 text-xs mt-2"
							>
								{{
									enable_lesson_report_sent
										? `Ở chế độ bật, các báo cáo cá nhân sẽ được tự động gửi đến phụ huynh sau khi hoàn thành.`
										: `Ở chế độ tắt, chỉ có giám đốc, quản lý cơ sở, trưởng chuyên môn và ${$filters.terminology('teacher')} thực hiện báo cáo mới có thể chọn gửi đến cho phụ huynh.`
								}}
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_lesson_report_sent"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo tuần cá nhân
							</div>
							<div
								class="font-normal text-neutral-500 leading-5 text-xs mt-2"
							>
								{{
									enable_weekly_report_sent
										? `Ở chế độ bật, các báo cáo bán trú sẽ được tự động gửi đến phụ huynh.`
										: `Ở chế độ tắt, chỉ có giám đốc, quản lý cơ sở, trưởng chuyên môn và ${$filters.terminology('teacher')} thực hiện báo cáo mới có thể chọn gửi đến cho phụ huynh.`
								}}
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_weekly_report_sent"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-white"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo can thiệp lớp nhóm
							</div>
							<div
								class="font-normal text-neutral-500 leading-5 text-xs mt-2"
							>
								Ở chế độ bật, các báo cáo ngày của lớp nhóm sẽ
								được tự động gửi đến phụ huynh.
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_group_lesson_report_sent"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo tuần lớp nhóm
							</div>
							<div
								class="font-normal text-neutral-500 leading-5 text-xs mt-2"
							>
								Ở chế độ bật, các báo cáo tuần của lớp nhóm sẽ
								được tự động gửi đến phụ huynh.
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_group_weekly_report_sent"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
			v-if="!isLitePackage"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">Hiển thị thống kê Chuyên cần</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					Ở chế độ bật, phụ huynh sẽ xem được số buổi học của trẻ
					trong các báo cáo dưới đây
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo tuần
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_session_count_for_weekly_report
							"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Báo cáo tháng
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_session_count_for_monthly_report
							"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
			v-if="flagCheck()"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">Điểm danh can thiệp cá nhân</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Đính kèm ảnh
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_attendance_track_with_media"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6"
						v-if="!isLitePackage"
					>
						<div>
							<div
								class="input-group__label uppercase text-neutral-400 text-xs font-semibold"
							>
								Tự động Gửi điểm danh đến phụ huynh
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_auto_send_attendance_tracks_to_parent
							"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
			v-if="flagCheck2() && !isLitePackage"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">Điểm danh lớp bán trú</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Đính kèm ảnh
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_day_care_class_attendance_track_with_media"
						/>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6"
					>
						<div>
							<div
								class="input-group__label uppercase text-neutral-400 text-xs font-semibold"
							>
								Tự động Gửi điểm danh đến phụ huynh
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_auto_send_day_care_class_attendance_tracks_to_parent
							"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="false"
			class="__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10"
		>
			<div
				class="__section__header font-semibold text-neutral-600 p-6 border-b"
			>
				Báo cáo ngày
				<div class="max-w-lg font-normal leading-5 text-sm mt-2">
					Ở chế độ bật, CSCT bắt buộc phải điền những thông tin đã bật
					khi tạo mục tiêu mới
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
					>
						<div
							class="input-group__label text-neutral-500 font-normal"
						>
							Bắt buộc điền hoạt động cho từng mục tiêu
						</div>
						<SwitchButton v-model:value="dateValue" />
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6"
					>
						<div
							class="input-group__label text-neutral-500 font-normal"
						>
							Bặt buộc điền ghi chú cho từng mục tiêu
						</div>
						<SwitchButton v-model:value="dateValue" />
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="false"
			class="__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10"
		>
			<div
				class="__section__header font-semibold text-neutral-600 p-6 border-b"
			>
				Báo cáo kế hoạch
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6"
					>
						<div>
							<div
								class="input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold"
							>
								Tùy chỉnh theo chu kỳ
							</div>
							<div
								class="font-normal text-neutral-500 leading-5 text-xs mt-2"
							>
								Tắt để giữ chu kỳ mặc định là mỗi tháng một báo
								cáo kế hoạch. Bật để tùy chỉnh chu kỳ của một
								báo cáo kế hoạch.
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_day_care_report_sent"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden"
		>
			<div class="flex items-center justify-between p-6 font-semibold">
				<div class="text-neutral-600">Thông báo nhắc việc</div>
				<button
					v-if="isEdit"
					type="button"
					class="button-p text-center whitespace-nowrap w-fit"
					@click="submitHour"
				>
					Lưu chỉnh sửa
				</button>
				<div v-else class="cursor-pointer" @click="isEdit = true">
					<img
						class="w-5 h-5"
						src="@/assets/images/icons/pen.png"
						alt=""
					/>
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50 gap-4"
					>
						<div class="input-group__label">
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-56"
							>
								Nhắc báo cáo ngày
							</div>
							<div
								class="text-xs text-neutral-500 font-normal leading-5 mt-2"
							>
								Ở chế độ bật, {{ $filters.terminology('teacher') }} nhận thông báo tự
								động nhắc làm báo cáo ngày và thông báo đến quản
								lý còn bao nhiêu báo cáo ngày chưa hoàn thành.
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_daily_report_notification"
						/>
					</div>
					<div v-if="enable_daily_report_notification">
						<div
							class="input-group flex-nowrap flex items-center py-6 pl-12 pr-6 bg-white"
						>
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-1/2"
							>
								Nhắc việc cho {{ $filters.terminology('teacher') }} lúc
							</div>
							<div v-if="isEdit" class="w-1/2">
								<VueDatepicker
									v-model="
										time_to_notify_daily_report_for_staff_object
									"
									autoApply
									class="input-date w-full"
									minutesIncrement="30"
									placeholder="Giờ bắt đầu buổi học"
									timePicker
									uid="start_opening_hour_DayCare"
								>
									<template #input-icon>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--lock"
										/>
									</template>
								</VueDatepicker>
							</div>
							<div class="text-neutral-800" v-else>
								{{
									addZero(
										time_to_notify_daily_report_for_staff_object.hours
									) +
									':' +
									addZero(
										time_to_notify_daily_report_for_staff_object.minutes
									)
								}}
							</div>
						</div>
						<div
							class="input-group flex-nowrap flex items-center py-6 pl-12 pr-6 bg-white"
						>
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-1/2"
							>
								Gửi thống kê cho quản lý lúc
							</div>
							<div v-if="isEdit" class="w-1/2">
								<VueDatepicker
									v-model="
										time_to_notify_daily_report_for_admin_object
									"
									autoApply
									class="input-date w-full"
									minutesIncrement="30"
									placeholder="Giờ bắt đầu buổi học"
									timePicker
									uid="start_opening_hour_DayCare"
								>
									<template #input-icon>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--lock"
										/>
									</template>
								</VueDatepicker>
							</div>
							<div class="text-neutral-800" v-else>
								{{
									addZero(
										time_to_notify_daily_report_for_admin_object.hours
									) +
									':' +
									addZero(
										time_to_notify_daily_report_for_admin_object.minutes
									)
								}}
							</div>
						</div>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50 gap-4"
					>
						<div class="input-group__label">
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-56"
							>
								Nhắc báo cáo tuần
							</div>
							<div
								class="text-xs text-neutral-500 font-normal leading-5 mt-2"
							>
								Ở chế độ bật, {{ $filters.terminology('teacher') }} nhận thông báo tự
								động nhắc làm báo cáo tuần và thông báo đến quản
								lý còn bao nhiêu báo cáo tuần chưa hoàn thành.
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_weekly_report_notification"
						/>
					</div>
					<div v-if="enable_weekly_report_notification">
						<div
							class="input-group flex-nowrap flex items-center py-6 pl-12 pr-6 bg-white"
						>
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-1/2"
							>
								Nhắc việc vào
							</div>
							<div v-if="isEdit" class="w-1/2">
								<div class="bg-white select-tabs">
									<Multiselect
										v-model="daySelected"
										:allow-empty="false"
										:options="dayOfWeek"
										:searchable="true"
										deselect-label="Đã chọn"
										label="nameSearch"
										placeholder="Chọn ngày nhắc việc"
										selectLabel=""
										track-by="name"
									>
										<template #noResult>
											Không tìm thấy kết quả
										</template>
										<template v-slot:option="props">
											<div
												class="flex flex-nowrap items-center"
											>
												<div>
													{{ props.option.name }}
												</div>
											</div>
										</template>
										<template
											v-slot:singleLabel="{ option }"
										>
											<div
												class="flex flex-nowrap items-center font-medium"
											>
												<div>{{ option.name }}</div>
											</div>
										</template>
									</Multiselect>
								</div>
							</div>
							<div class="text-neutral-800" v-else>
								{{
									Number(
										weekly_report_notification_day_of_week
									) === 7
										? 'Chủ nhật'
										: 'Thứ ' +
										  (Number(
												weekly_report_notification_day_of_week
										  ) +
												1)
								}}
							</div>
						</div>
						<div
							class="input-group flex-nowrap flex items-center py-6 pl-12 pr-6 bg-white"
						>
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-1/2"
							>
								Nhắc việc cho {{ $filters.terminology('teacher') }} lúc
							</div>
							<div v-if="isEdit" class="w-1/2">
								<VueDatepicker
									v-model="
										time_to_notify_weekly_report_for_staff_object
									"
									autoApply
									class="input-date w-full"
									minutesIncrement="30"
									placeholder="Giờ bắt đầu buổi học"
									timePicker
									uid="start_opening_hour_DayCare"
								>
									<template #input-icon>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--lock"
										/>
									</template>
								</VueDatepicker>
							</div>
							<div class="text-neutral-800" v-else>
								{{
									addZero(
										time_to_notify_weekly_report_for_staff_object.hours
									) +
									':' +
									addZero(
										time_to_notify_weekly_report_for_staff_object.minutes
									)
								}}
							</div>
						</div>
						<div
							class="input-group flex-nowrap flex items-center py-6 pl-12 pr-6 bg-white"
						>
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-1/2"
							>
								Gửi thống kê cho quản lý lúc
							</div>
							<div v-if="isEdit" class="w-1/2">
								<VueDatepicker
									v-model="
										time_to_notify_weekly_report_for_admin_object
									"
									autoApply
									class="input-date w-full"
									minutesIncrement="30"
									placeholder="Giờ bắt đầu buổi học"
									timePicker
									uid="start_opening_hour_DayCare"
								>
									<template #input-icon>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--lock"
										/>
									</template>
								</VueDatepicker>
							</div>
							<div class="text-neutral-800" v-else>
								{{
									addZero(
										time_to_notify_weekly_report_for_admin_object.hours
									) +
									':' +
									addZero(
										time_to_notify_weekly_report_for_admin_object.minutes
									)
								}}
							</div>
						</div>
					</div>
					<div
						class="input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50"
						v-if="!isLitePackage"
					>
						<div class="input-group__label">
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-56"
							>
								Nhắc đánh giá định kỳ
							</div>
							<div
								class="text-xs text-neutral-500 font-normal leading-5 mt-2"
							>
								Ở chế độ bật, thông báo nhắc đánh giá định kỳ
								cho học sinh sẽ được gửi đến Quản lý sau khi học
								sinh hoàn thành một lượng giờ học can thiệp cá
								nhân cố định. Nếu không sử dụng tính năng lịch
								học, Luca sẽ tính 1 báo cáo can thiệp cá nhân
								bằng 1 giờ can thiệp
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_periodic_assessment_notification
							"
						/>
					</div>
					<div v-if="enable_periodic_assessment_notification">
						<div
							class="input-group flex-nowrap flex items-center justify-between py-6 pl-12 pr-6"
						>
							<div
								class="uppercase text-neutral-400 text-xs font-semibold w-1/2"
							>
								Số giờ can thiệp cá nhân cần hoàn thành
							</div>
							<input
								v-if="isEdit"
								v-model="no_hour_to_noti_periodic_assessment"
								inputmode="numeric"
								type="number"
								class="bg-white input-with-icon w-1/2"
							/>
							<div v-else class="w-1/2">
								{{ no_hour_to_noti_periodic_assessment }} giờ
							</div>
						</div>
						<div class="input-group pb-6 pl-12 pr-6">
							<div class="flex items-center justify-between">
								<div
									class="uppercase text-neutral-400 text-xs font-semibold"
								>
									Danh sách học sinh
								</div>
								<button
									type="button"
									class="button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap w-fit"
									v-if="isEdit"
									@click="addStudents"
								>
									Thêm học sinh
								</button>
							</div>
							<PeriodicAssessment></PeriodicAssessment>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';
import { Prop, Watch } from 'vue-property-decorator';
import PercentSlideOver from './PercentSlideOver.vue';
import { $api } from '@/services';
import PeriodicAssessment from '@/views/setupCenter/features/periodicAssessment/PeriodicAssessment.vue';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { _ROUTER_NAME } from '@/enums';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { isLitePackage } from '@/helper/packageTier';
import { useStore } from 'vuex';

@Options({
	name: 'Report',
	components: {
		SwitchButton,
		PercentSlideOver,
		PeriodicAssessment,
		DaIcon,
		Multiselect,
	},
})
export default class Report extends Vue {
	//----------------------- 🤍 Props 🤍 -----------------------//
	@Prop() org;
	store = useStore();
	//----------------------- 🤍 Data 🤍 -----------------------//
	enable_half_year_report = true;
	enable_monthly_report = true;
	enable_quarterly_report = false;
	enable_weekly_report = false;
	enable_day_care_report_sent = false;
	enable_lesson_report_sent = false;
	enable_weekly_report_sent = false;
	enable_group_lesson_report_sent = false;
	require_goal_note = false;
	require_report_note = false;
	enable_auto_fill_assessment_report = false;
	onChange = false;
	onWatchOrg = true;
	dateValue = false;
	sideOverShow = false;
	enable_session_count_for_monthly_report = false;
	enable_session_count_for_weekly_report = false;
	enable_attendance_track_with_media = false;
	enable_auto_send_attendance_tracks_to_parent = false;
	enable_group_weekly_report_sent = false;
	autoFillData = null;
	isEdit = false;
	no_hour_to_noti_periodic_assessment = 130;
	enable_periodic_assessment_notification = false;
	enable_daily_report_notification = false;
	time_to_notify_daily_report_for_staff_object = 0;
	time_to_notify_daily_report_for_admin_object = 0;
	time_to_notify_weekly_report_for_staff_object = 0;
	time_to_notify_weekly_report_for_admin_object = 0;
	enable_weekly_report_notification = false;
	weekly_report_notification_day_of_week = 1;
	dayOfWeek = [
		{ name: 'Thứ 2', value: 1 },
		{ name: 'Thứ 3', value: 2 },
		{ name: 'Thứ 4', value: 3 },
		{ name: 'Thứ 5', value: 4 },
		{ name: 'Thứ 6', value: 5 },
		{ name: 'Thứ 7', value: 6 },
		{ name: 'Chủ nhật', value: 7 },
	];
	daySelected = null;
	enable_day_care_class_attendance_track_with_media = false;
	enable_auto_send_day_care_class_attendance_tracks_to_parent = false;

	get isLitePackage() {
		return isLitePackage(this.store.state.profile);
	}

	mounted() {
		this.getAutoFill();
	}

	flagCheck() {
		return FLAG_CHECK('CHECK_IN_CHECK_OUT');
	}

	flagCheck2(){
		return FLAG_CHECK('DAYCARE_ATTENDANCE');
	}

	async getAutoFill() {
		try {
			const {
				data: { data },
			} = await $api.org.getAutoFill();
			this.autoFillData = data;
		} catch (e) {
			console.log(e);
		}
	}

	addStudents() {
		this.$router.push({
			name: _ROUTER_NAME.SETUP_PERIODIC_ASSESSMENT_ADD_STUDENT,
		});
	}

	async submitHour() {
		try {
			let payload = {};
			if (this.enable_periodic_assessment_notification)
				payload.no_hour_to_noti_periodic_assessment =
					+this.no_hour_to_noti_periodic_assessment;
			if (this.enable_daily_report_notification) {
				payload.time_to_notify_daily_report_for_admin_object =
					this.time_to_notify_daily_report_for_admin_object;
				payload.time_to_notify_daily_report_for_staff_object =
					this.time_to_notify_daily_report_for_staff_object;
			}
			if (this.enable_weekly_report_notification) {
				payload.weekly_report_notification_day_of_week =
					this.weekly_report_notification_day_of_week;
				payload.time_to_notify_weekly_report_for_staff_object =
					this.time_to_notify_weekly_report_for_staff_object;
				payload.time_to_notify_weekly_report_for_admin_object =
					this.time_to_notify_weekly_report_for_admin_object;
			}
			this.$emit('updateOrg', payload);
		} catch (e) {
			console.log(e);
		}
	}

	submit() {
		this.getAutoFill();
		this.sideOverShow = false;
	}

	addZero(value) {
		if (value && value.toString()?.length <= 1) {
			return '0' + value;
		}
		if (value == '0') {
			return '00';
		}
		return value;
	}
	//----------------------- 🤍 Watch 🤍 -----------------------//

	@Watch('org', { deep: true, immediate: true })
	onOrgChange(org) {
		if (org && this.onWatchOrg) {
			this.enable_half_year_report = org?.enable_half_year_report;
			this.enable_monthly_report = org?.enable_monthly_report;
			this.enable_quarterly_report = org?.enable_quarterly_report;
			this.enable_weekly_report = org?.enable_weekly_report;
			this.enable_day_care_report_sent = org?.enable_day_care_report_sent;
			this.enable_session_count_for_monthly_report =
				org?.enable_session_count_for_monthly_report;
			this.enable_session_count_for_weekly_report =
				org?.enable_session_count_for_weekly_report;
			this.enable_auto_send_attendance_tracks_to_parent =
				org?.enable_auto_send_attendance_tracks_to_parent;
			this.enable_attendance_track_with_media =
				org?.enable_attendance_track_with_media;
			this.enable_periodic_assessment_notification =
				org?.enable_periodic_assessment_notification;
			this.enable_lesson_report_sent = org?.enable_lesson_report_sent;
			this.enable_weekly_report_sent = org?.enable_weekly_report_sent;
			this.enable_group_lesson_report_sent =
				org?.enable_group_lesson_report_sent;
			this.enable_group_weekly_report_sent =
				org?.enable_group_weekly_report_sent;
			this.require_goal_note = org?.require_goal_note;
			this.require_report_note = org?.require_report_note;
			this.enable_auto_fill_assessment_report =
				org?.enable_auto_fill_assessment_report;
			this.no_hour_to_noti_periodic_assessment =
				org?.no_hour_to_noti_periodic_assessment;
			this.enable_daily_report_notification =
				org?.enable_daily_report_notification;
			this.time_to_notify_daily_report_for_staff_object =
				org?.time_to_notify_daily_report_for_staff_object;
			this.time_to_notify_daily_report_for_admin_object =
				org?.time_to_notify_daily_report_for_admin_object;
			this.enable_weekly_report_notification =
				org?.enable_weekly_report_notification;
			this.weekly_report_notification_day_of_week =
				org?.weekly_report_notification_day_of_week;
			this.time_to_notify_weekly_report_for_staff_object =
				org?.time_to_notify_weekly_report_for_staff_object;
			this.time_to_notify_weekly_report_for_admin_object =
				org?.time_to_notify_weekly_report_for_admin_object;
			this.daySelected = this.dayOfWeek.find(
				(i) => i.value === org?.weekly_report_notification_day_of_week
			);
			this.enable_day_care_class_attendance_track_with_media =
				org?.enable_day_care_class_attendance_track_with_media;
			this.enable_auto_send_day_care_class_attendance_tracks_to_parent =
				org?.enable_auto_send_day_care_class_attendance_tracks_to_parent;
			setTimeout(() => {
				this.onChange = true;
			}, 1000);
			this.onWatchOrg = false;
		}
	}

	@Watch('daySelected')
	ondaySelected(data) {
		this.weekly_report_notification_day_of_week = data.value;
	}

	@Watch('require_goal_note')
	onRequestGoalNote(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				require_goal_note: value,
			});
		}
	}

	@Watch('require_report_note')
	onRequestGoalReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				require_report_note: value,
			});
		}
	}

	@Watch('enable_auto_fill_assessment_report')
	onRequestGoalReportAuto(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_auto_fill_assessment_report: value,
			});
		}
	}

	@Watch('enable_half_year_report')
	onHaftYearReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_half_year_report: value,
			});
		}
	}

	@Watch('enable_quarterly_report')
	onQuarterlyReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_quarterly_report: value,
			});
		}
	}

	@Watch('enable_weekly_report')
	onWeeklyReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_weekly_report: value,
			});
		}
	}

	@Watch('enable_day_care_report_sent')
	onEnable_day_care_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_day_care_report_sent: value,
			});
		}
	}

	@Watch('enable_session_count_for_monthly_report')
	onEnable_session_count_for_monthly_report(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_session_count_for_monthly_report: value,
			});
		}
	}

	@Watch('enable_session_count_for_weekly_report')
	onEnable_session_count_for_weekly_report(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_session_count_for_weekly_report: value,
			});
		}
	}

	@Watch('enable_lesson_report_sent')
	onEnable_lesson_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_lesson_report_sent: value,
			});
		}
	}

	@Watch('enable_weekly_report_sent')
	onEnable_weekly_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_weekly_report_sent: value,
			});
		}
	}
	@Watch('enable_auto_send_attendance_tracks_to_parent')
	onEnable_auto_sent_to_parent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_auto_send_attendance_tracks_to_parent: value,
			});
		}
	}
	@Watch('enable_attendance_track_with_media')
	onEnable_media_track(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_attendance_track_with_media: value,
			});
		}
	}
	@Watch('enable_group_lesson_report_sent')
	onEnable_group_lesson_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_group_lesson_report_sent: value,
			});
		}
	}
	@Watch('enable_group_weekly_report_sent')
	onEnable_group_weekly_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_group_weekly_report_sent: value,
			});
		}
	}
	@Watch('enable_periodic_assessment_notification')
	onEnable_periodic_assessment_notification(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_periodic_assessment_notification: value,
			});
		}
	}
	@Watch('enable_daily_report_notification')
	onEnable_daily_report_notification(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_daily_report_notification: value,
			});
		}
	}
	@Watch('enable_weekly_report_notification')
	onEnable_weekly_report_notification(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_weekly_report_notification: value,
			});
		}
	}
	@Watch('enable_day_care_class_attendance_track_with_media')
	onEnable_day_care_class_attendance_track_with_media(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_day_care_class_attendance_track_with_media: value,
			});
		}
	}
	@Watch('enable_auto_send_day_care_class_attendance_tracks_to_parent')
	onEnable_auto_send_day_care_class_attendance_tracks_to_parent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_auto_send_day_care_class_attendance_tracks_to_parent: value,
			});
		}
	}
}
</script>
<style scoped>
.goal-class {
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #1d283a;
}
</style>
